var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 23,
    viewBox: "0 0 280 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.342 8.94212C222.206 2.48748 166.45 8.24342 111.338 8.2263C74.895 8.20393 38.4157 6.85007 2.00381 7.01C0.912188 7.01732 0.0488223 8.38171 0.0764264 10.0694C0.104689 11.757 1.01339 13.1173 2.10435 13.1099C38.5123 12.9501 74.9877 14.3041 111.427 14.3266C166.439 14.3462 222.09 8.58273 277.127 15.0297C278.218 15.1546 279.149 13.9004 279.212 12.2206C279.268 10.541 278.427 9.07736 277.342 8.94212Z",
    fill: "#FACC15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.bdc6c277cd8e53f70f90fe27a96783da.svg";
export { ForwardRef as ReactComponent };